import logo from '~/assets/images/logo_rb.png';

const images = {
    logo: logo,
    noImage: require('~/assets/images/no-image.png'),
};

export default images;
